<ion-content (ionScroll)="onScroll($event)" scrollEvents="true">
  <div class="sb-sticky">
    <sb-simple-navbar [hasBackButton]="canGoBack">
      <h4 class="sb-back--title color-light">
        <span *ngIf="!!selectedName">{{ selectedName }} / </span>
        {{ 'aZDestMenu' | translate | lowercase }}
      </h4>
    </sb-simple-navbar>
  </div>
  <ion-list class="m-unset" *ngIf="eventos">
    <sb-dropdown
      *ngFor="let sport of eventos | dictionary; let index = index"
      [index]="index"
      [numItemsOpened]="10"
      [title]="sport?.key"
    >
      <sb-grid-item
        *ngFor="let event of sport?.val"
        [event]="event"
        [mode]="event?.mode"
        (navigate)="navigate($event, event)"
        [special]="sportBookService?.isSpecialMarket(event?.LeagueName)"
      >
        <!--template outlet for content-->
        <ng-container
          *ngTemplateOutlet="
                    event?.mode === 'teams' ? teams : expanded;
                    context: { event: event }
                  "
          content
        >
        </ng-container>

        <sb-overview-score-sets
          *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
          [sportHandle]="event?.SportHandle"
          [scoreboard]="event?.liveData"
          scoreboard
        >
        </sb-overview-score-sets>

        <sb-overview-score-regular
          *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
          [scoreboard]="event?.liveData"
          scoreboard
        >
        </sb-overview-score-regular>

        <div
          class="sb-grid-item--bets-group"
          [ngClass]="'has-' + event?.Games?.length + '-groups'"
          *ngFor="let game of event?.Games; let index = index"
          bet-display
          tappable
          (click)="navigate(event, event, game?.GameType)"
          [game]="game"
          [betType]="game?.DisplayTypeName"
          [desktop]="isDesktop"
          sb-markets
        >
          <sb-button
            *ngFor="let result of game?.Results; let index = index; trackBy: utils?.trackBy"
            [type]="game?.GameType"
            [typeName]="game?.DisplayTypeName"
            [game]="result"
            [results]="game?.Results"
            [index]="index"
            (bet)="bet($event, game, game?.Name, '1')"
            [selected]="newTicketFacade?.hasResult(result.NodeId)"
            [locked]="result?.Locked"
            [home]="event?.teamHome"
            [away]="event?.teamAway"
            [sport]="event?.SportHandle"
          >
          </sb-button>
        </div>
        <sb-counter
          *ngIf="!!event?.ChildrenCount && event?.mode !== 'expanded'"
          [count]="event?.ChildrenCount"
          (click)="navigate(event, event)"
          counter-button
        >
        </sb-counter>
      </sb-grid-item>
    </sb-dropdown>
  </ion-list>
  <codere-footer></codere-footer>
</ion-content>

<!--Overview Pages-->
<ng-template #teams let-event="event" content>
  <sb-grid-content-teams [event]="event" content></sb-grid-content-teams>
</ng-template>

<ng-template #expanded let-event="event" content>
  <sb-grid-content-expanded [title]="event?.Name" [date]="event?.StartDate | sportsExtractDate" content>
  </sb-grid-content-expanded>
</ng-template>
